// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"cc73790f","668":"1fbc5d8f","838":"4c89f2a1"}[chunkId] + ".js";
};